<template>
  <tr>
    <td>
      <div class="plaintext-sm">{{ careerServiceYear.yearOfService }}</div>
    </td>
    <td>
      <div class="plaintext-sm">{{ careerServiceYear.age }}</div>
    </td>
    <td>
      <div class="plaintext-sm">{{ careerServiceYear.calendarYear }}</div>
    </td>
    <td>
      <div class="plaintext-sm">{{ careerServiceYear.suggestedRank }}</div>
    </td>
    <td>
      <div class="form-group">
        <select class="form-control input-sm"
          :value="careerServiceYear.yearOfServiceRank" @change="onRankChange($event.target.value)">
          <option v-for="rank in careerServiceYear.overrideRanks" :key="rank" :value="rank">{{ rank }}</option>
        </select>
      </div>
    </td>
    <template v-if="careerServiceYear.reserveComponent">
      <td>
        <div class="form-group" :class="{ 'has-error': !careerServiceYear.reserveComponent.isValid }">
          <input type="number" class="form-control input-sm"
            :value="careerServiceYear.reserveComponent.activeDutyDays"
            @input="onActiveDutyDaysChange(Number($event.target.value))" min="0" />
        </div>
      </td>
      <td>
        <div class="plaintext-sm">{{ careerServiceYear.reserveComponent.membershipPoints }}</div>
      </td>
      <td>
        <div class="form-group" :class="{ 'has-error': !careerServiceYear.reserveComponent.isValid }">
          <input type="number" class="form-control input-sm"
            :value="careerServiceYear.reserveComponent.inactiveDutyDaysPaid"
            @input="onInactiveDutyDaysPaidChange(Number($event.target.value))" min="0" />
        </div>
      </td>
      <td>
        <div class="form-group" :class="{ 'has-error': !careerServiceYear.reserveComponent.isValid }">
          <input type="number" class="form-control input-sm"
            :value="careerServiceYear.reserveComponent.inactiveDutyDaysNonPaid"
            @input="onInactiveDutyDaysNonPaidChange(Number($event.target.value))" min="0" />
        </div>
      </td>
    </template>
    <template v-else-if="hasRc">
      <td></td>
      <td></td>
      <td></td>
      <td></td>
    </template>
  </tr>
</template>

<script>
import CareerServiceYearMixin from '@/js/mixins/calculator/career-service-year-mixin';

export default {
  mixins: [CareerServiceYearMixin],
};
</script>

<style lang="scss" scoped>
input, select {
  width: 70px !important;
}

td {
  text-align: center;
}
</style>
